import React from 'react';
import PropTypes from 'prop-types';

const WFDisclaimer = (props) => (
  <div className="disclaimer">
    You are being referred to Wealthfront Advisers LLC (“Wealthfront Advisers”)
    by Nerdwallet, Inc. (“Nerdwallet”). Wealthfront Advisers has engaged
    Nerdwallet to act as a solicitor and refer potential clients to Wealthfront
    Advisers via advertisements placed on Nerdwallet’s website. Nerdwallet and
    Wealthfront Advisers are not affiliated with one another and have no formal
    relationship outside this arrangement. Wealthfront Advisers has agreed to
    compensate Nerdwallet for its referral services, and under this agreement
    will pay Nerdwallet a cash fee when you open an account with Wealthfront
    Advisers after clicking through this page. You will not be charged anything
    in connection with this referral, and this arrangement will not affect the
    advisory fees you will pay to Wealthfront Advisers compared to other
    advisory clients of Wealthfront Advisers.
    {props.advLink && (
      <span>
        Additional information about Wealthfront Advisers may be found in its
        firm brochure located&nbsp;
        <a href={props.advLink}>here</a>.&nbsp;
      </span>
    )}
    By clicking on the button on this page, you acknowledge receipt of the
    foregoing disclosure and the firm brochure accessible via the link in the
    preceding sentence.
  </div>
);

WFDisclaimer.propTypes = {
  advLink: PropTypes.string,
};

WFDisclaimer.displayName = 'WFDisclaimer';

export default WFDisclaimer;
